export const formatDate = (value, fallback = "-") => {
    if (!value) return fallback;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return fallback;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`; // 01/10/2024
};

export const formatBillingDay = (value, fallback = "-") => {
    if (!value || value < 1 || value > 31) return fallback;
    return `${getOrdinal(value)} of month`;
};

export const formatAmount = (amount) => {
    return (amount < 0 ? '-' : '') + `£${Math.abs(amount)}`
}

const getOrdinal = (n) => {
    const mod10 = n % 10;
    const mod100 = n % 100;

    if (mod10 === 1 && mod100 !== 11) return `${n}st`;
    if (mod10 === 2 && mod100 !== 12) return `${n}nd`;
    if (mod10 === 3 && mod100 !== 13) return `${n}rd`;

    return `${n}th`;
};

export const formatSiteAddress = (site, fallback = "-") => {
    if (!site) 
        return fallback;

    const parts = [
        site.addressLine1,
        site.addressLine2,
        site.addressLine3,
        site.addressLine4,
        site.addressLine5,
        site.postcode,
    ]
    .map((part) =>
        typeof part === "string" 
            ? part.trim() 
            : part
    )
    .filter(Boolean);

    if (!parts.length) 
        return fallback;

    return parts.join(", ");
};

export const formatDateWithMonthName = (value, fallback = "-") => {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};